import React, { Component } from "react";
import { NavLink } from "react-router-dom";
import { EmployeeBenefitsWeeklyStats } from "./EmployeeBenefitsWeeklyStats";
import { ClaimsCards } from "pages/Claims/ClaimsCards";
import { PreregistrationCards } from "pages/Preregistration/PreregistrationCards";
import { WalkInModal } from "./WalkInModal";
import { QrCodeModal } from "./QrCodeModal";
import AuthService from "services/auth.service";
import queryString from "query-string";
import ClaimsService from "services/claims.service";
import PreregistrationService from "services/preregistration.service";
import moment from "moment";
import PreviousBtn from "assets/icons/Previous.svg";
import NextBtn from "assets/icons/Next.svg";


const location = AuthService.getPracticeLocation();
const currentUser = AuthService.getCurrentUser();

class WeekSelect extends Component {
  render() {
    return (
      <div className="ml-sm-4 mb-0">
        <button onClick={ this.props.prevWeek } className="arrow-btn-image">
          <img src={ PreviousBtn } alt="previous" className="page-prev-btn" />
        </button>

        <b className="font-size-6 px-2">{ this.props.start_date } - { this.props.end_date }</b>

        <button onClick={ this.props.nextWeek } className="arrow-btn-image">
          <img src={ NextBtn } alt="next" className="page-next-btn" />
        </button>
      </div>
    );
  }
}

class AppointmentsSection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      visit_items: []
    };
  }

  preregistrationsList() {
    const parameters = queryString.stringify({
      page: 1,
      per: 2,
      practice_location_id: location?.id
    });

    PreregistrationService.list(parameters).then(
      (data) => {
        this.setState({
          visit_items: data.visits
        });
      },
      (error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace('/eb/login');
        }
      }
    );
  };

  componentDidMount() {
    this.preregistrationsList();
  }

  render() {
    return (
      <div>
        <div className="d-flex align-items-end justify-content-between my-6">
          <h3 className="text-grey mt-4 mb-0">Upcoming Appointments</h3>

          <NavLink end={ true } to="/eb/preregistration" className="text-danger mb-0 font-size-7">
            View All Appointments
          </NavLink>
        </div>

        <div>
          <PreregistrationCards items={ this.state.visit_items } />
        </div>
      </div>
    )
  }
}

export class EmployeeBenefits extends Component {
  constructor(props) {
    super(props);

    this.state = {
      page: 1,
      claims_per: 2,
      claim_items: [],
      start_date: moment().subtract(6, 'days').format('YYYY-MM-DD'),
      end_date: moment().format('YYYY-MM-DD'),
      start_date_display: moment().subtract(6, 'days').format('DD MMM YYYY'),
      end_date_display: moment().format('DD MMM YYYY'),
    };

    this.weeklyStats = React.createRef();
  }

  claimsList() {
    const parameters = queryString.stringify({
      page: this.state.page,
      per: this.state.claims_per,
      practice_location_id: location?.id,
      start_date: this.state.start_date,
      end_date: this.state.end_date
    });

    ClaimsService.list(parameters).then(
      (data) => {
        this.setState({
          claim_items: data.claims
        });
      },
      (error) => {
        if (error.response.status === 401) {
          AuthService.logout();
          window.location.replace('/eb/login');
        }
      }
    );
  };

  componentDidMount() {
    this.claimsList();
  }

  refreshEverything() {
    this.claimsList();

    this.setState({
      start_date: moment().subtract(6, 'days').format('YYYY-MM-DD'),
      end_date: moment().format('YYYY-MM-DD'),
      start_date_display: moment().subtract(6, 'days').format('DD MMM YYYY'),
      end_date_display: moment().format('DD MMM YYYY')
    }, this.weeklyStats.current.reloadStats());
  }

  selectWeek(week) {
    const todayDate = moment();
    const startDate = moment(this.state.start_date);
    const endDate   = moment(this.state.end_date);
    let newStartDate;
    let newEndDate;

    if (week > 0) {
      newStartDate  = startDate.add(week, 'weeks');
      newEndDate    = endDate.add(week, 'weeks');
    } else {
      newStartDate  = startDate.subtract(-week, 'weeks');
      newEndDate    = endDate.subtract(-week, 'weeks');
    }

    if (newEndDate > todayDate || newStartDate > todayDate) {
      return;
    }

    this.setState({
      start_date: newStartDate.format('YYYY-MM-DD'),
      end_date: newEndDate.format('YYYY-MM-DD'),
      start_date_display: newStartDate.format('DD MMM YYYY'),
      end_date_display: newEndDate.format('DD MMM YYYY')
    }, () => {
      this.weeklyStats.current.reloadStats();
      this.claimsList();
    });
  }

  render() {
    if (currentUser && !currentUser.eb_enabled) return <div id="main-content-target">
      <h2 className="text-danger text-center">Welcome To The New Doctor Portal</h2><br/>
    </div>;

    return (
      <div id="main-content-target">
        <WalkInModal handleReload={() => this.refreshEverything()} />
        <QrCodeModal></QrCodeModal>
        <h2 className="header-title">Employee Benefits</h2>

        <div className="d-sm-flex justify-content-between align-items-end w-100">
          <h3 className="text-grey my-4">Weekly Reports</h3>
          <WeekSelect start_date={ this.state.start_date_display } end_date={ this.state.end_date_display } prevWeek={() => this.selectWeek(-1) } nextWeek={() => this.selectWeek(1) } />
        </div>

        <EmployeeBenefitsWeeklyStats ref={ this.weeklyStats } start_date={ this.state.start_date } end_date={ this.state.end_date } />
        <AppointmentsSection />

        <div className="d-flex align-items-end justify-content-between my-6">
          <h3 className="text-grey mt-4 mb-0">Claims</h3>

          <NavLink end={ true } to="/eb/claims" className="text-danger mb-0 font-size-7">
            View All Claims
          </NavLink>
        </div>

        <div>
          <ClaimsCards
            items={ this.state.claim_items }
            handleReload={() => this.refreshEverything() }
            startDateDisplay={ this.state.start_date_display }
            endDateDisplay={ this.state.end_date_display }
          />
        </div>
      </div>
    )
  }
}